import React, { useState, useRef } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import SerializableInventoryForm from './SerializableInventoryForm'
import * as components from '../../components'
import SlidingPane from 'react-sliding-pane'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch, useSelector } from 'react-redux'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'

export const EditNonSerializedInventoryItem = ({
  title,
  onSubmit,
  nonSerializedInventoryItem,
}) => {
  const formRef = useRef()
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { serializable_inventory_item, consignment_type } = useSelector(
    (state) => state.lists
  )

  const loadData = () => {
    !rights && dispatch(getRights(user))
    !serializable_inventory_item &&
      dispatch(getLists('SERIALIZABLE_INVENTORY_ITEM'))
    !consignment_type && dispatch(getLists('CONSIGNMENT_TYPE'))
  }

  const updateInventoryItems = (data) => {
    new rest.SerializableInventoryService(data.url)
      .makePutRequest(data)
      .then((response) => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Non Serialized item edited.'))
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  const NonSerializableInventoryFormWithData = connect((state) => ({
    initialValues: { ...nonSerializedInventoryItem }, // pull initial values from account reducer
  }))(SerializableInventoryForm)
  return (
    <>
      <ReactBootstrap.Dropdown.Item
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.EDIT} Edit
      </ReactBootstrap.Dropdown.Item>
      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onAfterOpen={loadData}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <NonSerializableInventoryFormWithData
          ref={formRef}
          onSubmit={updateInventoryItems}
          rights={rights}
          serializable_inventory_item={serializable_inventory_item}
          consignment_type={consignment_type}
          enableBulkMode={false}
        />
      </SlidingPane>
    </>
  )
}
